// // CourseRegistrationModal.jsx
// import React, { useState } from 'react';
// import axios from 'axios';
// import styles from '../styles/CourseRegistrationModal.module.css';

// const CourseRegistrationModal = ({ isOpen, courseId, courseName, onClose, onSubmit }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     Absende_Seite: 'Kursplan'
//   });

//   const [errors, setErrors] = useState({});

//   if (!isOpen) return null;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (errors[name]) {
//       setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
//     }
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const validate = () => {
//     const newErrors = {};

//     if (!formData.name.trim()) {
//       newErrors.name = "Bitte gib deine Name ein";
//     }

//     if (!formData.email.trim()) {
//       newErrors.email = "Bitte gib deine Email-Adresse ein";
//     } else {
//       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//       if (!emailRegex.test(formData.email)) {
//         newErrors.email = "Bitte gib eine gültige Email-Adresse ein";
//       }
//     }

//     return newErrors;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const newErrors = validate();
//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       return;
//     }

//     const payload = { Name: formData.name, Email: formData.email, Kurs: courseId, Absende_Seite: formData.Absende_Seite };

//     try {
//       const response = await axios.post(
//         process.env.REACT_APP_API_BASE_URL + "/items/Kursreservierungen",
//         payload
//       );
//       console.log("Response:", response.data);
//       onSubmit(payload, "Reservierung erfolgreich gesendet!");
//       setFormData({ name: '', email: '' });
//       onClose();
//     } catch (error) {
//       console.error("Error", error);
//     }
//   };

//   return (
//     <div className={styles.modalOverlay}>
//       <div className={styles.modalContent}>
//         <button onClick={onClose} className={styles.closeButton}>x</button>
//         <form noValidate onSubmit={handleSubmit}>
//           <p>
//             Deine Reservierung für den Kurs <strong>"{courseName}"</strong>
//           </p>
//           <label>
//             Name:
//             <input
//               type="text"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//             />
//             {errors.name && <span className={styles.error}>{errors.name}</span>}
//           </label>
//           <label>
//             Email:
//             <input
//               type="email"
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//             />
//             {errors.email && <span className={styles.error}>{errors.email}</span>}
//           </label>
//           <button type="submit">Jetzt Reservieren!</button>
//         </form>

//       </div>
//     </div>
//   );
// };

// export default CourseRegistrationModal;



// import React, { useState } from 'react';
// import axios from 'axios';
// import PhoneInput from 'react-phone-input-2';
// import 'react-phone-input-2/lib/style.css';
// import styles from '../styles/CourseRegistrationModal.module.css';

// const CourseRegistrationModal = ({ isOpen, courseId, courseName, onClose, onSubmit }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     telefon: '',
//     Absende_Seite: 'Kursplan'
//   });

//   const [errors, setErrors] = useState({});

//   if (!isOpen) return null;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (errors[name]) {
//       setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
//     }
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handlePhoneChange = (value) => {
//     if (errors.telefon) {
//       setErrors(prevErrors => ({ ...prevErrors, telefon: '' }));
//     }
//     setFormData(prev => ({ ...prev, telefon: value }));
//   };

//   const validate = () => {
//     const newErrors = {};

//     if (!formData.name.trim()) {
//       newErrors.name = "Bitte gib deinen Namen ein";
//     }

//     if (!formData.email.trim()) {
//       newErrors.email = "Bitte gib deine Email-Adresse ein";
//     } else {
//       const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//       if (!emailRegex.test(formData.email)) {
//         newErrors.email = "Bitte gib eine gültige Email-Adresse ein";
//       }
//     }

//     if (!formData.telefon.trim()) {
//       newErrors.telefon = "Bitte gib deine Telefonnummer ein";
//     }

//     return newErrors;
//   };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   const newErrors = validate();
//   //   if (Object.keys(newErrors).length > 0) {
//   //     setErrors(newErrors);
//   //     return;
//   //   }

//   //   const payload = {
//   //     Name: formData.name,
//   //     Email: formData.email,
//   //     Telefon: formData.telefon,
//   //     Kurs: courseId,
//   //     Absende_Seite: formData.Absende_Seite
//   //   };

//   //   try {
//   //     const response = await axios.post(
//   //       process.env.REACT_APP_API_BASE_URL + "/items/Kursreservierungen",
//   //       payload
//   //     );
//   //     console.log("Response:", response.data);
//   //     onSubmit(payload, "Reservierung erfolgreich gesendet!");
//   //     setFormData({ name: '', email: '', telefon: '', Absende_Seite: 'Kursplan' });
//   //     onClose();
//   //   } catch (error) {
//   //     console.error("Error", error);
//   //   }
//   // };

// const handleSubmit = async (e) => {
//   e.preventDefault();
//   const newErrors = validate();
//   if (Object.keys(newErrors).length > 0) {
//     setErrors(newErrors);
//     return;
//   }

//   const kursReservierungPayload = {
//     Name: formData.name,
//     Email: formData.email,
//     Telefon: formData.telefon,
//     Kurs: courseId,
//     Absende_Seite: formData.Absende_Seite
//   };

//   try {
//     // 1. Создаём Kursreservierung
//     const kursResponse = await axios.post(
//       process.env.REACT_APP_API_BASE_URL + "/items/Kursreservierungen",
//       kursReservierungPayload
//     );
//     const kursReservierungId = kursResponse.data.data.id;

//     // 2. Создаём связанный Angebot_Anfrage
//     const angebotPayload = {
//       vorname: formData.name,
//       nachname: '', // Можно оставить пустым или добавить, если будет поле
//       email: formData.email,
//       telefon: formData.telefon,
//       kurs_reservierung: kursReservierungId,
//       Absende_Seite: "Kursplan",
//       status: "draft" // или "published", если нужно сразу опубликовать
//     };

//     await axios.post(
//       process.env.REACT_APP_API_BASE_URL + "/items/Angebot_Anfrage",
//       angebotPayload
//     );

//     // Завершение
//     onSubmit(kursReservierungPayload, "Reservierung erfolgreich gesendet!");
//     setFormData({ name: '', email: '', telefon: '', Absende_Seite: 'Kursplan' });
//     onClose();
//   } catch (error) {
//     console.error("Fehler beim Absenden:", error);
//   }
// };




//   return (
//     <div className={styles.modalOverlay}>
//       <div className={styles.modalContent}>
//         <button onClick={onClose} className={styles.closeButton}>x</button>
//         <form noValidate onSubmit={handleSubmit}>
//           <p>
//             Deine Reservierung für den Kurs <strong>"{courseName}"</strong>
//           </p>
//           <label>Name:</label>
//           <input
//             type="text"
//             name="name"
//             value={formData.name}
//             onChange={handleChange}
//           />
//           {errors.name && <span className={styles.error}>{errors.name}</span>}

//           <label>Email:</label>
//           <input
//             type="email"
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//           />
//           {errors.email && <span className={styles.error}>{errors.email}</span>}

//           <label>Telefon:</label>
//           <PhoneInput
//             country={'at'}
//             value={formData.telefon}
//             onChange={handlePhoneChange}
//             preferredCountries={['at', 'de', 'ch']}
//             enableSearch={true}
//             disableSearchIcon={false}
//             inputProps={{
//               name: 'telefon',
//               required: true,
//               id: 'telefon',
//             }}
//             containerClass={styles.formGroup}
//             inputClass={styles.input}
//           />
//           {errors.telefon && <span className={styles.error}>{errors.telefon}</span>}

//           <button type="submit">Jetzt Reservieren!</button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default CourseRegistrationModal;








import React, { useState } from 'react';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import styles from '../styles/CourseRegistrationModal.module.css';

const CourseRegistrationModal = ({ isOpen, courseId, courseName, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    vorname: '',
    nachname: '',
    email: '',
    telefon: '',
    Absende_Seite: 'Kursplan'
  });

  const [errors, setErrors] = useState({});

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (errors[name]) {
      setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
    }
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (value) => {
    if (errors.telefon) {
      setErrors(prevErrors => ({ ...prevErrors, telefon: '' }));
    }
    setFormData(prev => ({ ...prev, telefon: value }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.vorname.trim()) {
      newErrors.vorname = "Bitte gib deinen Vornamen ein";
    }

    if (!formData.nachname.trim()) {
      newErrors.nachname = "Bitte gib deinen Nachnamen ein";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Bitte gib deine Email-Adresse ein";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Bitte gib eine gültige Email-Adresse ein";
      }
    }

    if (!formData.telefon.trim()) {
      newErrors.telefon = "Bitte gib deine Telefonnummer ein";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const kursReservierungPayload = {
      Vorname: formData.vorname,
      Nachname: formData.nachname,
      // Name: `${formData.vorname} ${formData.nachname}`,
      Email: formData.email,
      Telefon: formData.telefon,
      Kurs: courseId,
      Absende_Seite: formData.Absende_Seite
    };

    try {
      const kursResponse = await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/items/Kursreservierungen",
        kursReservierungPayload
      );
      const kursReservierungId = kursResponse.data.data.id;

      /* const angebotPayload = {
        vorname: formData.vorname,
        nachname: formData.nachname,
        email: formData.email,
        telefon: formData.telefon,
        kurs_reservierung: kursReservierungId,
        Absende_Seite: "Kursplan",
        status: "draft"
      };

      await axios.post(
        process.env.REACT_APP_API_BASE_URL + "/items/Angebot_Anfrage",
        angebotPayload
      ); */

      onSubmit(kursReservierungPayload, "Reservierung erfolgreich gesendet!");
      setFormData({
        vorname: '',
        nachname: '',
        email: '',
        telefon: '',
        Absende_Seite: 'Kursplan'
      });
      onClose();
    } catch (error) {
      console.error("Fehler beim Absenden:", error);
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <button onClick={onClose} className={styles.closeButton}>x</button>
        <form noValidate onSubmit={handleSubmit}>
          <p>
            Deine Reservierung für den Kurs <strong>"{courseName}"</strong>
          </p>

          {errors.vorname && <span className={styles.error}>{errors.vorname}</span>}
          {/* <label>Vorname</label> */}
          <input
            type="text"
            name="vorname"
            value={formData.vorname}
            onChange={handleChange}
            placeholder='Vorname'
          />

          {errors.nachname && <span className={styles.error}>{errors.nachname}</span>}
          {/* <label>Nachname</label> */}
          <input
            type="text"
            name="nachname"
            value={formData.nachname}
            onChange={handleChange}
            placeholder='Nachname'
          />

          {errors.email && <span className={styles.error}>{errors.email}</span>}
          {/* <label>Email</label> */}
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder='Email'
          />
          
          {errors.telefon && <span className={styles.error}>{errors.telefon}</span>}
          {/* <label>Telefon</label> */}
          <PhoneInput
            country={'at'}
            value={formData.telefon}
            onChange={handlePhoneChange}
            preferredCountries={['at', 'de', 'ch']}
            enableSearch={true}
            disableSearchIcon={false}
            inputProps={{
              name: 'telefon',
              required: true,
              id: 'telefon',
            }}
            containerClass={styles.formGroup}
            inputClass={styles.input}
          />

          <button type="submit">Jetzt Reservieren!</button>
        </form>
      </div>
    </div>
  );
};

export default CourseRegistrationModal;
